import {codeObject, datasourceTypeObject, stnEntity} from "../common/constructorObject";
import {floodObject} from "../flood/model/FloodObjects";

const {createSlice, createEntityAdapter} = require("@reduxjs/toolkit");


const rainFloodSliceAdapter = createEntityAdapter();

export const RAIN_FLOOD_SLICE = 'rainFloodConstructor';

const rainFloodSlice = createSlice({
    name: RAIN_FLOOD_SLICE,
    initialState: rainFloodSliceAdapter.getInitialState({
        ...floodObject
    }),
    reducers: {
        addNewFilter: (state) => {
            const rows = state.filters
            const newRow = {
                rainfall: {
                    type: {...(rows[rows.length-1].rainfall.type)},
                    code: {...codeObject},
                    stnEntity: {...stnEntity}
                },
                level: {
                    type: {...(rows[rows.length-1].level.type)},
                    code: {...codeObject},
                    stnEntity: {...stnEntity}
                }
            }
            state.filters.push(newRow)
        },
        deleteFilter: (state, action) => {
            const index = action.payload
            state.filters.splice(index, 1)
        },

        selectStation: (state, action) => {
            Object.assign(state.station, action.payload)
        },
        selectRainfallDatasourceType: (state, action) => {
            const index = action.payload.rowNum
            const row = state.filters[index].rainfall
            row.type = {...datasourceTypeObject}
            Object.assign(state.filters[index].rainfall.type, action.payload.res)
        },
        selectLevelDatasourceType: (state, action) => {
            const index = action.payload.rowNum
            const row = state.filters[index].level
            row.type = {...datasourceTypeObject}
            Object.assign(state.filters[index].level.type, action.payload.res)
        },
        selectRainfallCode: (state, action) => {
            const index = action.payload.rowNum
            const row = state.filters[index].rainfall
            row.code = {...codeObject}
            Object.assign(state.filters[index].rainfall.code, action.payload.res)
        },
        selectRainfallEntity: (state, action) => {
            const index = action.payload.rowNum
            const row = state.filters[index].rainfall
            row.stnEntity = {...stnEntity}
            Object.assign(state.filters[index].rainfall.stnEntity, action.payload.res)
        },
        selectLevelCode: (state, action) => {
            const index = action.payload.rowNum
            const row = state.filters[index].level
            row.code = {...codeObject}
            Object.assign(state.filters[index].level.code, action.payload.res)
        },
        selectLevelEntity: (state, action) => {
            const index = action.payload.rowNum
            const row = state.filters[index].level
            row.stnEntity = {...stnEntity}
            Object.assign(state.filters[index].level.stnEntity, action.payload.res)
        },
        selectEquation: (state, action) => {
            state.equation = action.payload
        },
        selectCoefficientA: (state, action) => {
            state.coefficients.A = action.payload
        },
        selectCoefficientB: (state, action) => {
            state.coefficients.B = action.payload
        },
        selectCoefficientC: (state, action) => {
            state.coefficients.C = action.payload
        },
        selectCoefficientD: (state, action) => {
            state.coefficients.D = action.payload
        },
        selectCatchmentArea: (state, action) => {
            state.catchmentArea = action.payload
        },
        setNewRainFloodConstructor: (state, action) => {
            state.name = action.payload.name
            state.station = action.payload.station
            state.filters = action.payload.filters
            state.equation = action.payload.equation
            state.coefficients = action.payload.coefficients
            state.catchmentArea = action.payload.catchmentArea
        },
    }

})

export default rainFloodSlice.reducer;

export const {
    addNewFilter,
    deleteFilter,
    selectStation,
    selectRainfallDatasourceType,
    selectLevelDatasourceType,
    selectRainfallEntity,
    selectLevelEntity,
    selectEquation,
    selectCoefficientA,
    selectCoefficientB,
    selectCoefficientC,
    selectCoefficientD,
    selectCatchmentArea,
    setNewRainFloodConstructor,
    selectLevelCode,
    selectRainfallCode
} = rainFloodSlice.actions
